import { GeneralResourceDetail, ProgramEngagementModel, ProgramEngagementStatus } from '@cibo/core'
import { useMemo } from 'react'
import { useProgramEngagementDetails } from '../../../../hooks/useProgramEngagementDetails'

export const useEvaluateStatus = (engagement?: ProgramEngagementModel | null) => {
  const { data: details, isLoading } = useProgramEngagementDetails<
    GeneralResourceDetail<Record<any, any>>
  >({
    resourceId: engagement?.id,
  })
  const evaluateStatus = useMemo(() => {
    return (stepStatus?: ProgramEngagementStatus) => {
      if (
        !details?.filter(a => a.traitId === 'eqipApplicationResults')[0]?.value?.applicationApproved
      ) {
        return {
          ...stepStatus,
          status: { ...stepStatus?.status, eligibility: { eligible: false } },
        } as ProgramEngagementStatus
      }
      return stepStatus
    }
  }, [isLoading])
  return { evaluateStatus, isLoading }
}
